import 'uni-pages';import 'uni-h5';import '@dcloudio/vue-cli-plugin-uni/packages/uni-cloud/dist/index.js';import Vue from 'vue'
import VueCompositionAPI from '@vue/composition-api'
import App from './App'

// 导入 rem.js 文件（仅在 H5 环境中生效）

import './static/js/rem.js'


Vue.use(VueCompositionAPI)
import uView from "uview-ui"
Vue.use(uView)
import store from './store/index.js'
import VueI18n from 'vue-i18n'
import messages from './common/lang.js'
Vue.prototype.$store=store
Vue.config.productionTip = false
App.mpType = 'app'
Vue.use(VueI18n)
const i18n = new VueI18n({  
  locale: uni.getStorageInfoSync('language') === '2' || uni.getStorageInfoSync('language') === null ? 'en-US' : 'zh-CN',  // 默认选择的语言(1:中文,2:英文<这里默认英文>)
  messages 
})
Vue.prototype._i18n = i18n
Vue.config.productionTip = false
App.mpType = 'app'
const app = new Vue({
	i18n,
    ...App
})
app.$mount() //挂载Vue实例
//v1.3.5起 H5端 你应该去除原有的app.$mount();使用路由自带的渲染方式
//
// 	RouterMount(app,router,'#app')
//

//

